export default "__VITE_ASSET__Cy5R0OnR__"